import React, { FC } from 'react';
import { RichText } from '@sitecore-jss/sitecore-jss-react';
import { appendToUrlPath } from '../../../utils/link.utils';
import Picture from '../../@shared/picture';
import RoutableNotEditableLink from '../../@shared/routableNotEditableLink';
import { TCardProps } from '../types/cards.types';
import { appendRootToRichTextInternalLinks } from '../../../utils/appendRootToRichTextInternalLinks.utils';
import './styles.scss';

const DashboardCard: FC<TCardProps & { shouldAppendRootToRichTextInternalLinks?: boolean }> = (props) => {
  const editable = props.isEditable || false;
  const cardDescription = props?.shouldAppendRootToRichTextInternalLinks
    ? { value: appendRootToRichTextInternalLinks(props?.fields?.shortDescription || props?.fields?.description?.value) }
    : props?.fields?.description;

  return (
    <RoutableNotEditableLink href={appendToUrlPath(props?.baseUrl || '', props.fields?.titleUrl || '')} className={'dashboard-card'}>
      <div className="dashboard-card__image-wrapper">
        <Picture
          editorialImageProps={
            props.fields?.editorialImageProps && {
              ...props.fields?.editorialImageProps,
              cssClassImageEl: 'dashboard-card__image',
            }
          }
          productImageProps={
            props.fields?.productImageProps && {
              ...props.fields.productImageProps,
              imageClassName: 'dashboard-card__image',
            }
          }
        />
      </div>
      <div>
        <RichText tag="h3" className="dashboard-card__title" field={props.fields?.title || {}} editable={editable} />
        <RichText tag="div" editable={editable} field={cardDescription || {}} className={'dashboard-card__description rich-text'} />
      </div>
    </RoutableNotEditableLink>
  );
};

export default DashboardCard;
